import {useSuspenseQuery} from '@tanstack/react-query';
import {getQueryKey} from '@shared/queryKeyMap';
import {useState} from 'react';
import {MaintenanceScheduleResponse} from '@di-shared/api/di/__generated';
import {diApi} from '@di-shared/api/di';

export interface UseSestManagementParams {
  sestCode: string;
  vin: string;
}

function useSestManagementSetting({sestCode, vin}: UseSestManagementParams) {
  const {data} = useSuspenseQuery({
    queryKey: [getQueryKey(diApi.maintenancesScheduleController.getMaintenanceSchedule1), vin, sestCode],
    queryFn: () => diApi.maintenancesScheduleController.getMaintenanceSchedule1({vin, sestCode}),
    select: (data) => data.data,
  });

  const [managementCycleType, setManagementCycleType] = useState<MaintenanceScheduleResponse.stdType>(
    data?.stdType ?? MaintenanceScheduleResponse.stdType.OWNER_MANUAL
  );

  function selectCycleType(stdType: MaintenanceScheduleResponse.stdType) {
    setManagementCycleType(stdType);
  }

  const [customDaysLeft, setCustomDaysLeft] = useState<number>(data?.customStdDays ?? data.stdDays);
  const [customDistance, setCustomDistance] = useState<number>(data?.customStdDistance ?? data.stdDistance);

  function changeCustomDaysLeft(daysLeft: number) {
    setCustomDaysLeft(daysLeft);
  }

  function changeCustomDistance(customDistance: number) {
    setCustomDistance(customDistance);
  }

  return {
    sestName: data.sestName,
    customDaysLeft,
    customDistance,
    managementCycleType,
    maintenanceType: data.maintenanceType,
    selectCycleType,
    changeCustomDaysLeft,
    changeCustomDistance,
    stdDistance: data.stdDistance,
    stdDays: data.stdDays,
  };
}

export default useSestManagementSetting;
